export function sortByKey<T>(items: T[], key: string, inverse?: boolean) {
  // put the items in a new array to prevent readonly error
  const sortedItems = [...items];

  return sortedItems.sort(function (a, b) {
    const valA = findDeepKey(a, key);
    const valB = findDeepKey(b, key);

    return compareProperties(valA, valB, inverse);
  });
}

export function findDeepKey(obj: any, path: any) {
  return path.split('.').reduce((prev: any, curr: any) => {
    return prev ? prev[curr] : undefined;
  }, obj);
}

export function compareProperties(a: number | string | Date, b: number | string | Date, invert?: boolean) {
  const notA = a === undefined || a === null || a === '';
  const notB = b === undefined || b === null || b === '';
  let result = 0;

  if ((notA && notB) || a === b) {
    result = 0;
  } else if (notB || a > b) {
    result = 1;
  } else if (notA || a < b) {
    result = -1;
  }

  // apply inversion
  return (invert ? -1 : 1) * result;
}

export function sortByUserLastName<T extends { user?: { lastName?: string | null } | null }>(items: T[]): T[] {
  return sortByKey(items, 'user.lastName');
}

export function downloadFile(url: string) {
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', '');

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
